import cn from "classnames";
import { trailerNumber, truckNumber } from "helpers/validators";
import moment from "moment";
import React from "react";
import InputMask from "react-input-mask";
import PhoneInput from "react-phone-input-2";
import ru from "react-phone-input-2/lang/ru";
import Template from "./template";

export default class Field extends Template {
    componentDidMount() {
        this.setState(this.initialState);
        this.validate(this.props.value, { isValid: true });
        this.initialValue = this.props.value;
        switch (this.props.type) {
            case "carNumber":
                this.invalidNumber = this.props.value && truckNumber(this.props.value).length > 0;
                break;
            case "trailerNumber":
                this.invalidNumber = this.props.value && trailerNumber(this.props.value).length > 0;
                break;
            default:
                break;
        }
    }

    setValue = ({ target }) => {
        const { inputProps, onChange, value } = this.props;
        if (onChange) {
            const currentValue = this.formatValue(target.value);
            this.validate(currentValue);
            if (inputProps.disabled) {
                return onChange({ name: inputProps.name, value });
            }
            return onChange({ name: inputProps.name, value: currentValue });
        }
    };

    formatValue = (value) => {
        const { type, inputProps } = this.props;
        switch (type) {
            case "carNumber":
                return value.replace(/[ _]/g, "");
            case "trailerNumber":
                return value.replace(/[ _]/g, "");
            case "number": {
                if (!value) {
                    return value;
                }
                return inputProps.step && inputProps.step !== "1" ? parseFloat(value) : parseInt(value);
            }
            default:
                return value;
        }
    };

    renderField = () => {
        const { inputProps, value, textarea, type, disabled, index, order } = this.props;
        const tabIndex = this.context?.baseTabIndex || 0;
        const name = index === undefined ? inputProps.name : `${inputProps.name}_${index}`;
        const props = {
            type: "text",
            className: "field-wrap__input",
            ...inputProps,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            value: value === null || value === undefined ? "" : value,
            onChange: this.setValue,
            disabled: disabled || inputProps.disabled,
            name,
            onWheel: (e) => e.target.blur(),
            tabIndex: order === undefined ? tabIndex : order + tabIndex,
        };
        if (textarea) {
            return (
                <textarea
                    {...props}
                    className={cn("field-wrap__input field-wrap__input--textarea", inputProps.className)}
                />
            );
        }
        const russianNumberLetter = /[авекмнорстухАВЕКМНОРСТУХ]/;
        const digit = /[0-9]/;
        const defaultInput = <input {...props} />;
        if (["customMask", "carNumber", "trailerNumber", "dayNumber", "timespan"].includes(type)) {
            delete props.maxLength;
        }
        const phoneNumberProps = {
            ...props,
            className: "",
            country: "ru",
            localization: ru,
            placeholder: "Введите номер телефона",
            onChange: (value) => this.setValue({ target: { value: `+${value}` } }),
            dropdownStyle: {
                width: "220px",
                maxHeight: "110px",
                margin: "5px 0",
            },
            inputProps: {
                ...inputProps,
                className: "field-wrap__input--phone",
            },
        };
        switch (type) {
            case "phone":
                return <PhoneInput {...phoneNumberProps} />;
            case "trailerNumber": {
                const trailerMaskProps = {
                    mask: [
                        russianNumberLetter,
                        russianNumberLetter,
                        " ",
                        digit,
                        digit,
                        digit,
                        digit,
                        " ",
                        "/",
                        " ",
                        digit,
                        digit,
                        digit,
                    ],
                };
                return this.invalidNumber ? defaultInput : <InputMask {...trailerMaskProps} {...props} />;
            }
            case "carNumber": {
                const carMaskProps = {
                    mask: [
                        russianNumberLetter,
                        " ",
                        digit,
                        digit,
                        digit,
                        " ",
                        russianNumberLetter,
                        russianNumberLetter,
                        " ",
                        "/",
                        " ",
                        digit,
                        digit,
                        digit,
                    ],
                };
                return this.invalidNumber ? defaultInput : <InputMask {...carMaskProps} {...props} />;
            }
            case "dayNumber": {
                const dayMaskProps = {
                    mask: "99",
                    maskPlaceholder: "",
                };
                return <InputMask {...dayMaskProps} {...props} value={(props.value ?? "").toString()} />;
            }
            case "customMask": {
                const mask = {
                    mask: this.props.mask,
                    maskPlaceholder: this.props.maskPlaceholder,
                };
                return <InputMask {...mask} {...props} value={(props.value ?? "").toString()} />;
            }
            case "timespan": {
                const duration = moment.duration(this.initialValue);
                const timespanProps =
                    duration.asDays() > 1
                        ? {
                              mask: [
                                  ...[...`${Math.floor(duration.asDays())}`].map(() => /[0-9]/),
                                  ".",
                                  /[0-2]/,
                                  value && value[`${Math.floor(duration.asDays())}`.length + 1] === "2"
                                      ? /[0-3]/
                                      : /[0-9]/,
                                  ":",
                                  /[0-5]/,
                                  /[0-9]/,
                              ],
                              maskPlaceholder: `${[...`${Math.floor(duration.asDays())}`].map(() => "д").join("")}.чч:мм`,
                          }
                        : {
                              mask: [/[0-2]/, value && value[0] === "2" ? /[0-3]/ : /[0-9]/, ":", /[0-5]/, /[0-9]/],
                              maskPlaceholder: "чч:мм",
                          };
                return <InputMask {...timespanProps} {...props} />;
            }
            default:
                return defaultInput;
        }
    };
}
